export default Object.freeze({
  FOR: 'For',
  AGAINST: 'Against',
  DONT_KNOW: 'Don\'t know'
})



// WEBPACK FOOTER //
// ./src/enums/opinion.js